import { render, staticRenderFns } from "./registerEntry_tl5_themeOne.vue?vue&type=template&id=0703167c&scoped=true"
import script from "./registerEntry_tl5_themeOne.vue?vue&type=script&lang=js"
export * from "./registerEntry_tl5_themeOne.vue?vue&type=script&lang=js"
import style0 from "./registerEntry_tl5_themeOne.vue?vue&type=style&index=0&id=0703167c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0703167c",
  null
  
)

export default component.exports